import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import classnames from 'classnames';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { NotificationManager } from "react-notifications";
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import moment from 'moment';
import { BreadCrumb } from '../../../components/breadcrumb';
import { Loader } from '../../../components/loader';
import { fetchAdministereds, deleteAdministereds } from "../../../actions/administered";
import AddAdministeredTypeForm from "../../settings/addAdministeredType";
import EditAdministered from './editAdministered';  


const AdministeredType ={
  Vaccine : "Vaccine",
  Treatment : "Treatment"
};
const { SearchBar } = Search;
const $ = window.$;
class Vaccines extends React.Component{
  constructor(props){
      super(props);
      this.state = {
        selectedTab: 'Vaccine',
        vaccineData: [],
        treatmentData: [],
        loading: true,
        mediModalType: "",
        administeredData:{},
        deleteMedicationId : null,

      };
  }

  tableHeaderVaccineColumnData = [
    {dataField : "actions" , text : "Actions"  ,
    headerStyle: (column, colIndex) => {
      return { width: '100px' };
    },
     formatter : (cell, row) => {
      return ( 
        <div>     
          <button    
            onClick={(e) => this.onEditClick(e, row)}
            className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
            title="View"
          >
                <i className="far fa-edit"></i>
          </button>
          <button
          onClick={(e) => {          
              this.openConfirmModal(e, row.id)
          }}
            className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
          >
              <i className="la la-trash-o"></i> 
          </button>
        </div>
      );
    }},
    {dataField : "name" , text : "Name" ,sort: true },
   
    {dataField : "type" , text : "Type" ,sort: true },
    {
      dataField: 'createdAt', text: 'Created Date', formatter: cell => moment(cell).format('MM/DD/YYYY h:mm:ss a'), sort: true
    },
  ];

  tableHeaderTreatmentColumnData = [
    {dataField : "actions" , text : "Actions", 
    headerStyle: (column, colIndex) => {
      return { width: '100px' };
    },
    formatter : (cell, row) => {
      return ( 
        <div>     
        <button
          onClick={(e) => this.onEditClick(e, row)}
          className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
          title="View"
        >
              <i className="far fa-edit"></i>
        </button>
        <button
        onClick={(e) => {          
             this.openConfirmModal(e, row.id)
        }}
          className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
         >
            <i className="la la-trash-o"></i> 
        </button>
        </div>
      );
    }},
    {dataField : "name" , text : "Name" ,sort: true, },
    {dataField : "type" , text : "Type" ,sort: true, },
    {
      dataField: 'createdAt', text: 'Created Date', formatter: cell => moment(cell).format('MM/DD/YYYY h:mm:ss a'), sort: true,
    },
  ];

  items = [
    { title: 'Breeders', to: '/breeders' },
    { title: 'Vaccines & treatments', to: '/breeders/vaccines-treatments'}
  ];

  componentDidMount = () => {
    this.props.fetchAdministereds(); 
  };

  componentWillReceiveProps = (nextProps, prevProps) => {

    if (
      nextProps.administered &&
      this.props.administered !== nextProps.administered &&
      nextProps.administered.length > 0
    ) {

      let vaccines = nextProps.administered.filter((item)=>{
       return  item.type == 'vaccine'
      });
    
      let treatment = nextProps.administered.filter((item)=>{
        return  item.type == 'deworm'
       });   
       this.setState({
        vaccineData:vaccines,
        treatmentData: treatment,
        loading: false
       });    
    }

    if(this.props.administeredListError !== nextProps.administeredListError ){
      NotificationManager.error("An error occurred while loading the vaccines & treatments");
      this.setState({ loading: false });
    }

    if (
      this.props.data.administeredTypeReducer.setAdministered !==
      nextProps.data.administeredTypeReducer.setAdministered
    ) {
      this.props.fetchAdministereds();
    }  

    if(nextProps.updatedAdministered && nextProps.updatedAdministered !== this.props.updatedAdministered){
      this.props.fetchAdministereds(); 
      this.setState({ loading: false });
      
    }

    if(nextProps.deletedAdministered && nextProps.deletedAdministered !== this.props.deletedAdministered){
  
      NotificationManager.success("Administered type deleted successfully");    
      $("#confirm_delete_modal").modal("hide");
      this.props.fetchAdministereds();

    }

    if(nextProps.deleteddAdministeredError && nextProps.deleteddAdministeredError !== this.props.deleteddAdministeredError){
  
      if(nextProps.deleteddAdministeredError.message){
        $("#confirm_delete_modal").modal("hide");
        NotificationManager.error(nextProps.deleteddAdministeredError.message)
      }
    }   
    
  };

  AddNewAdministered = (e, type) => {
    e.preventDefault();
    this.setState({ mediModalType: type, showAdministered: true });   
  };

  onEditClick = (e,row) =>{ 
   this.setState({administeredData: row});
   $("#edit_administered_type").modal("show");
  
  }

  openConfirmModal(e,id){
    this.setState({ deleteMedicationId : id });
    $("#confirm_delete_modal").modal("show");  
  }

  deleteMedication(e){
    let id = this.state.deleteMedicationId;
    this.props.deleteAdministereds(id);
  }

  render(){
  const { vaccineData, treatmentData, mediModalType, administeredData } = this.state;
   return (
    <div className="m-grid m-grid--hor m-grid--root m-page">
      <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background"> 
      {/* <BreadCrumb items={this.items} /> */}
      <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
        <div className="m-grid__item m-grid__item--fluid m-wrapper">
          <div className="m-portlet m-portlet--mobile">
            <div className="m-portlet__head">
               <div className="m-portlet__head-caption">
                 <div className="m-portlet__head-title">
                   <h3 className="m-portlet__head-text">
                     Medical Record Vaccines & Treatments               
                   </h3>
                 </div>
               </div>
            </div>
            <div className="m-portlet__body">
                  <ul className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn" role="tablist">
                    <li className="nav-item m-tabs__item">
                      <button className={classnames({ "nav-link m-tabs__link btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true, "active": this.state.selectedTab === 'Vaccine' })} onClick={() => this.setState({ selectedTab: 'Vaccine' })}>Vaccines</button>
                    </li>                                        
               
                    <li className="nav-item m-tabs__item">
                      <button className={classnames({ "nav-link m-tabs__link btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true, "active": this.state.selectedTab === 'Treatment' })} onClick={() => this.setState({ selectedTab: 'Treatment' })}>Treatments</button>
                    </li>
                             
                  </ul>
                  <div className="tab-content">
               
                    {['Vaccine', 'Treatment'].indexOf(this.state.selectedTab) >= 0 &&
                      <div className="tab-pane active" role="tabpanel">
                     
                      <div className="m-form m-form--label-align-right m--margin-top-20 m--margin-bottom-30">
                       <div className="row align-items-center">
                        <div className="col-xl-8 order-2 order-xl-1">
                        </div>
                        <div className="col-xl-4 order-1 order-xl-2 m--align-right">
                        {this.state.selectedTab === 'Vaccine' ?
                          <a href="#" className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill" 
                            data-toggle="modal"
                            data-target="#add_administered_type"
                            onClick={e =>
                            this.AddNewAdministered(e,"vaccine")
                          } 
                        >
                        <span>
                          <i className="la la-plus"></i>
                          <span>
                          New Vaccine
                          </span>
                        </span>
                        </a>:
                        <a href="#" className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill" 
                           data-toggle="modal"
                           data-target="#add_administered_type"
                           onClick={e =>
                           this.AddNewAdministered(e,"deworm")
                           } 
                        >
                          <span>
                            <i className="la la-plus"></i>
                             <span>
                             New Treatment
                             </span>
                          </span>
                       </a>
                       }
                      </div>
                      </div>
                      </div>                                    
                     
                        {this.state.loading ?
                          <div className="center-row">
                            <Loader size={50}/>
                          </div>
                          :
                          <ToolkitProvider
                            keyField="id"
                            data={this.state.selectedTab === AdministeredType.Vaccine ? vaccineData : this.state.selectedTab === AdministeredType.Treatment ? treatmentData :  {}}
                            columns={this.state.selectedTab === AdministeredType.Vaccine ? this.tableHeaderVaccineColumnData : this.state.selectedTab === AdministeredType.Treatment ? this.tableHeaderTreatmentColumnData: {}}
                            search                      
                          >
                            {
                              props => (
                                <div>
                                  <div className='px-0 mb-4 search-bar'>
                                  <div className='col-lg-9 px-0'>
                                        <h5 className="mt-3">{this.state.selectedTab === AdministeredType.Vaccine ? 'Vaccines' : this.state.selectedTab === AdministeredType.Treatment ? 'Treatments' : ''}</h5>
                                    </div>
                                    <div className='col-lg-3 px-0 inner-addon right-addon'>
                                      <i className="fas fa-search"></i>
                                      <SearchBar {...props.searchProps} />
                                    </div>
                                  </div>

                                  <BootstrapTable
                                    classes="petTable"
                                    {...props.baseProps}                                 
                                    pagination={paginationFactory()}                                  
                                  />
                                </div>
                              )
                            }
                          </ToolkitProvider>
                        }
                      </div>
                    }      
                  </div>
            </div>
          </div>
        </div>
      </div>
       </div> 
      <div className="modal fade" id="confirm_delete_modal" tabIndex="-1" role="dialog" aria-labelledby="ConfirmationModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Confirm to delete</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this administered type?</p>
                        </div>
                        <div className="modal-footer">                    
                            <div>
                                <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                                <button type="button" onClick={(e) => this.deleteMedication(e)} className="btn btn-primary m-btn--pill">Confirm</button>
                            </div>                  
                        </div>
                    </div>
                </div>
        </div>
      <AddAdministeredTypeForm type={mediModalType} />  
      <EditAdministered treatmentData={administeredData} />
    </div>
  )
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
  petShop: state.petShopReducer,
  data: state,
  currentUser: state.breederReducer.currentUser, 
  administered: state.administeredTypeReducer.administeredList,
  updatedAdministered: state.administeredTypeReducer.updatedAdministered,
  deletedAdministered: state.administeredTypeReducer.deletedAdministered,
  deleteddAdministeredError: state.administeredTypeReducer.deleteddAdministeredError,
  administeredListError : state.administeredTypeReducer.administeredListError,
});

const mapDispatchToProps = dispatch => ({
  fetchAdministereds: () => {
    dispatch(fetchAdministereds());
  },  
  deleteAdministereds: (id) => {
    dispatch(deleteAdministereds(id));
  }
});

Vaccines = connect(mapStateToProps, mapDispatchToProps)(Vaccines);
export default withRouter(Vaccines);